import React, { useEffect, useState } from 'react';
import { createAsyncThunk } from "@reduxjs/toolkit"
import store from "../../../core/app/store"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import { RootState } from "../../../core/app/store"
import { setSelectTxDataSave } from '@/UDTreat/udTreatSlice';
import {
  initialfinal,
  stageControl,
  toothMovement,
  EBiteJumpLocationType,
  viewControlInTreatment,
  caseManagement,
  history,
  stagingManager,
} from "@/gluelayer"

export default class SCCallbackManager {
  private static instance: SCCallbackManager;
  private uploadAllDataCallBack: any;
  private reloadBiteJumpCallBack: any;
  private asyncQuitStagingCallBack: any;
  private asyncCheckingBeforeQuitIprCallBack: any;
  private execCurrentStepCallBack: any;
 
  private constructor() {
    this.uploadAllDataCallBack = null;
    this.reloadBiteJumpCallBack = null;
    this.asyncQuitStagingCallBack = null;
    this.asyncCheckingBeforeQuitIprCallBack = null;
    this.execCurrentStepCallBack = null;
  }
 
  public static getInstance(): SCCallbackManager {
    if (!SCCallbackManager.instance) {
      SCCallbackManager.instance = new SCCallbackManager();
    }
    return SCCallbackManager.instance;
  }
 
  public setUploadAllDataCallBack(callBack: any): void {
    this.uploadAllDataCallBack = callBack;
  }

  public getUploadAllDataCallBack(): any {
    return this.uploadAllDataCallBack;
  }

  public setReloadBiteJumpCallBack(callBack: any): void {
    this.reloadBiteJumpCallBack = callBack;
  }

  public getReloadBiteJumpCallBack(): any {
    return this.reloadBiteJumpCallBack;
  }
  public setAsyncQuitStagingCallBack(callBack: any): void {
    this.asyncQuitStagingCallBack = callBack;
  }
  public getAsyncQuitStagingCallBack(): any {
    return this.asyncQuitStagingCallBack;
  }
  public setAsyncCheckingBeforeQuitIprCallBack(callBack: any): void {
    this.asyncCheckingBeforeQuitIprCallBack = callBack;
  }
  public getAsyncCheckingBeforeQuitIprCallBack(): any {
    return this.asyncCheckingBeforeQuitIprCallBack;
  }
  public setExecCurrentStepCallBack(callBack: any): void {
    this.execCurrentStepCallBack = callBack;
  }
  public getExecCurrentStepCallBack(): any {
    return this.execCurrentStepCallBack;
  }
}

export function isNodeContains(nodeTypes, nodeType) {
  //console.info("=====nodeTypes: " + nodeTypes.length)
  if (nodeTypes.length > 0) {
    //console.info(nodeTypes[0])
  }
  let index = nodeTypes.indexOf(nodeType)
  //console.info("index:" + index)
  return index >= 0
}

// export const waitForUserHandleTxDataChange = createAsyncThunk(
//   "stageCommon/waitForUserHandleTxDataChange",
//   async (arg, { rejectWithValue, getState }) => {

//     try {
//       const unsubscribe = store.subscribe(() => {
//         const newData = store.getState().udTreatService.selectTxDataSave;
//         if (newData === "save_yes") {
//           unsubscribe();
//           return;
//         }
//         else if (newData === "save_no") {
//           unsubscribe();
//           return;
//         }
//       })
//     } catch (err) {
//       return rejectWithValue(err)
//     }
//   },
// )

export const checkTxDataChange = async () => {
  await userSelectTxChangeSave()
  // const isTxDataChanged = caseManagement.getTxDataChanged()
  // if(isTxDataChanged)
  // {
  //   const dispatch = useAppDispatch()
  //   dispatch(setSelectTxDataSave("save_show"))
  //   await userSelectTxChangeSave()
  // }
};

export const userSelectTxChangeSave = async (invokeUpload = true) => {
  return new Promise((resolve) => {
    const unsubscribe = store.subscribe(() => {
      const newData = store.getState().udTreatService.selectTxDataSave;
      console.info("checkTxDataChange selectTxDataSave:", newData)
      if (newData === "save_yes") {
        unsubscribe();
        // caseManagement.saveCurrentTx(true)
        if(invokeUpload && SCCallbackManager.getInstance().getUploadAllDataCallBack()) {
          SCCallbackManager.getInstance().getUploadAllDataCallBack()({ callback: () => { resolve(newData) } })
        } else {
          resolve(newData)
        }
      }
      else if (newData === "save_no") {
        unsubscribe();
        caseManagement.saveCurrentTx(false)
        if((window as any).pulloutCallback()){
          (window as any).pulloutCallback()
        }
        resolve(newData);
      }
      else if (newData === "save_cancel") {
        unsubscribe();
        resolve(newData);
      }
    });
  });
};

export class StageCommon {
  private static instance: StageCommon = null;
  private dragBarStep: number;
  private stageTwoButtonWarningMessageResult: string;
  private stageOneButtonWarningMessageResult: string;
 
  private constructor() {
    this.dragBarStep = 0;
  }
 
  public static getInstance(): StageCommon {
    if (!StageCommon.instance) {
      StageCommon.instance = new StageCommon();
    }
    return StageCommon.instance;
  }

  public setDragBarStep(step:number) : void {
    this.dragBarStep = step;
    // console.info("StageCommon setDragBarStep:" + step)
  }

  public getDragBarStep(): number {
    // console.info("StageCommon getDragBarStep:" + this.dragBarStep)
    return this.dragBarStep;
  }

  public setStageTwoButtonWarningMessageResult(result: string) : void {
    this.stageTwoButtonWarningMessageResult = result;
  }

  public getStageTwoButtonWarningMessageResult(): string {
    return this.stageTwoButtonWarningMessageResult;
  }

  public setStageOneButtonWarningMessageResult(result: string) : void {
    this.stageOneButtonWarningMessageResult = result;
  }

  public getStageOneButtonWarningMessageResult(): string {
    return this.stageOneButtonWarningMessageResult;
  }

  public stageTwoButtonWarningMessageResultListening = async () => {
    return new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const stageTwoButtonWarningMessage = store.getState().udTreatService.stageTwoButtonWarningMessage;
        console.info("stageTwoButtonWarningMessage:", stageTwoButtonWarningMessage)
        const resultStr = this.getStageTwoButtonWarningMessageResult();
        console.info("getStageTwoButtonWarningMessageResult:", resultStr)
        unsubscribe();
        resolve(resultStr);
      });
    });
  };

  public stageOneButtonWarningMessageResultListening = async () => {
    return new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const stageOneButtonWarningMessage = store.getState().udTreatService.stageOneButtonWarningMessage;
        console.info("stageOneButtonWarningMessage:", stageOneButtonWarningMessage)
        const resultStr = this.getStageOneButtonWarningMessageResult();
        console.info("getStageOneButtonWarningMessageResult:", resultStr)
        unsubscribe();
        resolve(resultStr);
      });
    });
  };
}

